import connect from './connect';
import PhoneButton from './PhoneButton';

export default connect(PhoneButton);
